import AbstractContext from '@/shared/models/AbstractContext';
import User from '@/shared/models/User';
import { mergeInto, removeById, updateById } from '@/shared/utils';
import TaskStatus from '../constants/TaskStatus';
import Memo from './Memo';
import Task, { TaskId } from './Task';

export default abstract class TaskContext extends AbstractContext {
  tasks: Array<Task> = [];
  memos: Array<Memo> = [];

  getResolvableTasks(): Array<Task> {
    return this.tasks.filter(t => t.canResolve());
  }

  getVisibleMemos(): Array<Memo> {
    return this.memos.filter(m => !m.resolvedOn);
  }

  addTask(task: Task): void {
    mergeInto(task, this.tasks);
  }

  removeTask(taskId: TaskId): void {
    removeById(this.tasks, taskId);
  }

  updateTaskOwner(owner: User | null, taskId: TaskId): void {
    updateById(this.tasks, taskId, task => task.ownedBy = owner);
  }

  resolveTask(taskId: TaskId, resolver?: User): void {
    updateById(this.tasks, taskId, task => {
      if (resolver) task.resolvedBy = resolver;
      task.status = TaskStatus.RESOLVED;
    });
  }

  resolveMemo(memo: Memo, user: User): void {
    memo.resolve(user);
  }

  removeMemo(memo: Memo): void {
    removeById(this.memos, memo.id);
  }
}